module.exports = __webpack_public_path__ + "img/11_asia.d7b78887.png";